import { generateMongoId } from '@/helpers/common/mongo.helper';

import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { Venue } from 'sonata-static-storage/lib/schemas/venue/venue.schema';

export function generateVenueGroup(name: Venue['name']): UserInterface['venueGroups'][0] {
  return {
    _id: generateMongoId(),
    color: '#4A4470',
    groupType: 'custom',
    icon: 'fa-location-dot',
    name
  };
}
